import { render, staticRenderFns } from "./OrderDiscountsBox.vue?vue&type=template&id=25f5ef76&scoped=true&"
import script from "./OrderDiscountsBox.vue?vue&type=script&lang=js&"
export * from "./OrderDiscountsBox.vue?vue&type=script&lang=js&"
import style0 from "./OrderDiscountsBox.vue?vue&type=style&index=0&id=25f5ef76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5ef76",
  null
  
)

export default component.exports